import React from 'react';
import { compact, sortBy, get } from 'lodash';
import { GridItem } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';

export interface MetadataOption {
  label: string;
  value: string;
}

export interface AttributeMetadata {
  label?: string;
  visibility?: string;
  order?: number;
  metadataOptions?: Record<string, number>;
  [key: string]: unknown;
}

interface MetadataAttributeProps {
  name?: string;
  options?: MetadataOption[];
  metadata?: AttributeMetadata;
}

export const MetadataAttribute = ({ name, options = [], metadata }: MetadataAttributeProps) => {
  const filteredOptions = sortBy(compact(options), (option) => get(metadata, `metadataOptions.${option.value}`, 0));

  if (!(name && metadata && filteredOptions.length > 0)) {
    return null;
  }

  return (
    <GridItem as="li">
      <Typography color="grey_800">{metadata.label}</Typography>
      <Typography color="grey_1000">{filteredOptions.map((option) => option.label).join(', ')}</Typography>
    </GridItem>
  );
};

export default MetadataAttribute;
